export function vaildNull(value) {
  return value === undefined || value === null || value === '' || (Array.isArray(value) && value.length == 0)
}
